import { useReduxState } from './use-redux';

export interface CandidateInfo {
    personName: string | null;
    jobTitle: string | null;
    clientName: string | null;
}

interface UseCandidateInfoArgs {
    personId: string;
    jobId: string;
}

/**
 * Gets candidate info (person name, job title, client name) from Redux state
 * given a personId and jobId.
 */
export function useCandidateInfo({ personId, jobId }: UseCandidateInfoArgs): CandidateInfo {
    const job = useReduxState((state) => (jobId ? state.jobs.get(jobId) : null));
    const client = useReduxState((state) => {
        if (!job?.clientId) return null;
        return state.clients.list?.find((c) => c.id === job.clientId) ?? null;
    });
    const personDetails = useReduxState((state) => {
        if (!personId) return null;
        return state.personsDetails.list?.get(personId) ?? null;
    });

    return {
        clientName: client?.name ?? null,
        jobTitle: job?.title ?? null,
        personName: personDetails?.person?.name?.full ?? null
    };
}
